import React from "react";

export const Contact = () => (
    <>
    <h1>This is the contact page</h1>
    </>
);